import React from 'react'
import styled from 'styled-components'

function Texto({ children, backgroundColor, color }) {
  return (
    <Wrapper>
      <Content className='animate__animated animate__fadeIn' backgroundColor={backgroundColor} color={color}>{children}</Content>
    </Wrapper>
  )
}

export default Texto

const Wrapper = styled.div`
    width:100%;
`;

const Content = styled.p`
    color:  ${props=> props.color ? props.color : 'var(--color-blanco)'};
    background-color: ${props=> props.backgroundColor ? props.backgroundColor : 'var(--color-morado-oscuro)'};
    padding:40px;
    
    b{
      font-weight:900;
      color: var(--color-azul-claro)
    }
    small{
      font-size:.6em;
    }
`;